import { render, staticRenderFns } from "./UserDetailContactsTile.vue?vue&type=template&id=08f4f420&scoped=true&lang=pug&"
import script from "./UserDetailContactsTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailContactsTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailContactsTile.vue?vue&type=style&index=0&id=08f4f420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f4f420",
  null
  
)

export default component.exports